
export default function RegularizationSection() {
  return (
    <section className="py-16 bg-[#F2F2F2]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://public.readdy.ai/ai/img_res/5ff4b0a8753e6b9d62288b23f30eb3ed.jpg"
                alt="Regularização e Documentação de Obras"
                className="w-full h-80 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#5C1A24]/20 to-transparent"></div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-[#5C1A24] rounded-full flex items-center justify-center mr-4">
                <i className="ri-file-text-line text-white text-xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24]" style={{ fontFamily: '"Playfair Display", serif' }}>
                Regularização e Documentação de Obras
              </h2>
            </div>
            
            <div className="text-[#3F3F3F] leading-relaxed space-y-4">
              <p>
                Cuidamos de licenças, alvarás, habite-se e regularizações junto aos órgãos competentes.
              </p>
              <p>
                Transformamos burocracia em tranquilidade — resolvemos com agilidade e dentro dos prazos.
              </p>
              <p className="font-medium text-[#5C1A24]">
                Especialistas em situações complexas que travam obras e impedem o uso de imóveis.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                'Licenças e alvarás',
                'Habite-se',
                'Regularizações',
                'Suporte jurídico'
              ].map((feature, index) => (
                <div key={index} className="flex items-center">
                  <i className="ri-check-line text-[#5C1A24] mr-2"></i>
                  <span className="text-sm text-[#3F3F3F]">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
